import { PedidoEmailer } from './email';
import { PedidoReporter } from './report';
import { PedidoDuplicater } from './duplicate';
import { PedidoCancelar } from './cancelamento';
import { PedidoEditavel } from './form';
import { PedidoConfirmavel } from './confirmar';
import { PedidoConfirmavelErp, PedidoIntegraterErp } from './integration-erp';
import { PedidoAmostravel } from './pedido-amostravel';
import { PedidoPipelineCard } from './pedido-pipeline-card';
import { CanalVenda } from '../common/canais-venda/domain';

/** Representa um pedido na pesquisa dos pedidos **/
export class PedidoSearch implements PedidoEmailer, PedidoReporter, PedidoDuplicater, PedidoCancelar, PedidoEditavel, PedidoConfirmavel, PedidoConfirmavelErp, PedidoIntegraterErp, PedidoAmostravel {
    id: number;
    idEmpresa: number;
    origemLancamento: number;
    numero: number;
    tipoVenda: number;
    operacaoVenda: number;
    status: number;
    statusAmostra: number;
    dataEmissao: Date;
    dataConfirmacao: Date;

    // Pessoa
    idPeriodo: number;
    idPessoa: number;
    codigoIntegracaoErpPessoa: string;
    nomePessoa: string;
    nomeFantasiaPessoa: string;
    idClassificacaoFaturamentoPretendida: number;
    codigoIntegracaoErpClassificacaoFaturamentoPretendida: string;
    nomeClassificacaoFaturamentoPretendida: string;
    indicadorCustomerSharePretendido: number;

    idRepresentante: number;
    codigoIntegracaoErpRepresentante: string;
    nomeRepresentante: string;
    nomeFantasiaRepresentante: string;
    idTabelaPreco: number;
    codigoIntegracaoErpTabelaPreco: string;
    nomeTabelaPreco: string;
    quantidadeTotal: number;
    valorItens: number;
    valorTotal: number;
    percDescontoMedio: number;
    prazoMedio: number;
    pedidoFilho: boolean;
    paletizacao: boolean;
    responsavelCliente: string;
    responsavelEmpresa: string;
    aplicaClausulaReajuste: boolean;
    precoFixoAte: Date;
    motivoReprovado: string;
    numeroPedidoCliente: string;
    anotacao: string;
    tipoFrete: number;
    idCotacao: number;
    idLocalFaturamento: number;
    codigoIntegracaoErpEmpresaLocalFaturamento: string;
    nomeLocalFaturamento: string;

    // Canal de Venda
    idCanalVenda: number;
    canalVenda: CanalVenda;
    numeroCanalVenda: string;

    // Cupons de Desconto
    cuponsDesconto: string[];

    // Conta e Ordem
    operacaoContaOrdem: number;

    // Cancelamento
    dataCancelamento: Date;
    idUsuarioCancelamento: number;
    nomeUsuarioCancelamento: string;
    idMotivoCancelado: number;
    nomeMotivoCancelado: string;
    motivoCancelamento: string;

    // GEP
    setorGep: number;
    dataAnaliseFinanceiro: Date;
    dataFaturamento: Date;

    // Expedição
    quantidadeVolumesPrevistos: number;
    quantidadeVolumesEfetivos: number;
    dataInicioExpedicao: Date;
    dataTerminoExpedicao: Date;
    previsaoSeparacaoExpedicaoDias: number;

    // D.R.P (Demonstração do Resultado do Pedido)
    valorIpi: number;
	// Lucro Líquido
	valorLucroLiquido: number;
	percLucroLiquido: number;
	percLucroLiquidoAbaixo: boolean;
    // Grupo de Rentabilidade - Qualidade de Valor (QV)
    idGrupoRentabilidade: number;
    nomeGrupoRentabilidade: string;
    escalaGrupoRentabilidade: number;
    escalaSimboloGrupoRentabilidade: string;


    // Pedido não liberado
    motivoNaoLiberado: number;
    dataNaoLiberado: Date;
    // Pedido Não Liberado - Bonificações
    valorRegraNaoLiberado: number;
    tipoRegraBonificacaoNaoLiberado: number;
    valorBonificacaoNaoLiberado: number;
    percBonificacaoNaoLiberado: number;
    percBonificacaoMaximaNaoLiberado: number;
    // Não Liberado Venda
    valorLucroLiquidoNaoLiberado: number;
    percLucroLiquidoNaoLiberado: number;
    percLucroLiquidoMinimoNaoLiberado: number;
    // Liberado
    dataLiberado: Date;
    idUsuarioLiberado: number;
    nomeUsuarioLiberado: string;
    justificativaLiberado: string;

    // Pagamento
    tipoPagamento: number;
    idCondicaoPagamento: number;
    codigoIntegracaoErpCondicaoPagamento: string;
    nomeCondicaoPagamento: string;
    prazoMedioCondicaoPagamento: number;
    idFormaPagamento: number;
    codigoIntegracaoErpFormaPagamento: string;
    nomeFormaPagamento: string;

    /** Se algum item do pedido está com a caixa de embarque fracionada */
    pedidoFracionado: boolean;

    // Negócio
    idNegocio: number;
    numeroNegocio: number;
    idFunilVendaEtapaOportunidade: number;
    tipoFunilVendaEtapaOportunidade: number;
    nomeFunilVendaEtapaOportunidade: string;
    corFunilVendaEtapaOportunidade: number;
    podeSolicitarRevisaoOrcamento: boolean
    podeEditarRevisaoOrcamento: boolean;
    podeRevisarOrcamento: boolean;

    // Campanha
    idCampanha: number;
    numeroCampanha: number;
    nomeCampanha: string;
    statusCampanha: number;
    idAreaCampanha: number;

    // Integração ERP
    idIntegracaoErp: number;
    nomeIntegracaoErp: string;
    logoURLPlataformaIntegracaoErp: string;
    numeroErp: string;
    integradoErp: boolean;

    // Integração E-commerce
    idIntegracaoEcommerce: number;
    nomeIntegracaoEcommerce: string;
    logoURLPlataformaIntegracaoEcommerce: string;
    numeroEcommerce: string;

    // Card do pipeline dos pedidos
    pipelineCard: PedidoPipelineCard;

    constructor(props: Partial<PedidoSearch>) {
        Object.assign(this, props);

        if (props) {
            // Canal de Venda
            this.canalVenda = CanalVenda.getById(props.idCanalVenda);
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): PedidoSearch {
        return new PedidoSearch(JSON.parse(json));
    }
}
